
export default {
  data() {
    return {
      benefits: this.$t('benefits.blocks'),
    }
  },
}
